import { BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { TAG_PARTNER_APPLICATION_SETTINGS } from 'services/TagsConstants';

import { FormDataType } from '../constants/PartnerAppSettingsFormConstants';

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
  build.mutation<void, FormDataType>({
    query: (patch) => {
      return {
        url: 'system/partner-application-setting',
        method: 'PATCH',
        body: patch,
      };
    },
    invalidatesTags: [TAG_PARTNER_APPLICATION_SETTINGS],
  });
